import { $, debug } from '../bootstrap';
import * as maps from '../shared/maps';
import order from './order';

export default {
    load() {
        debug.bench('MovingServices:load');

        order.load();

        $('#businessCarousel').carousel();

  

        const partners = [
          { src: "/assets/img/partners/logo_rtbf.jpg", alt: "RTBF - on est pas de pigeons", href: "https://www.rtbf.be/info/societe/onpdp/pigeons-ou-pas-pigeons/detail_boxify-bruxelles-pour-stocker-votre-surplus-en-toute-securite?id=947480" },
          { src: "/assets/img/partners/logo_on-est-pas-des-pigeons.jpg", alt: "RTBF - on est pas de pigeons", href: "https://www.rtbf.be/info/societe/onpdp/pigeons-ou-pas-pigeons/detail_boxify-bruxelles-pour-stocker-votre-surplus-en-toute-securite?id=9474804" },
          { src: "/assets/img/partners/logo_la-libre.jpg", alt: "La libre", href: "http://www.lalibre.be/video/boxify-une-nouvelle-solution-bruxelloise-de-stockage-57e92273cd70f8c3926f0389" },
          { src: "/assets/img/partners/logo_ladh.jpg", alt: "DH.BE", href: "http://www.dhnet.be/video/boxify-une-nouvelle-solution-bruxelloise-de-stockage-57e92273cd70f8c3926f0382" },
          { src: "/assets/img/partners/logo_vivre-ici.jpg", alt: "Vivre Ici", href: "http://www.vivreici.be/article/detail_boxify-une-nouvelle-solution-de-stockage-bruxelloise-pour-les-entreprises-et-particuliers?id=102297" },
          { src: "/assets/img/partners/logo_digital-energy-solution.jpg", alt: "Solution Magazine", href: "https://www.solutions-magazine.com/boxify-reinvente-stockage-physique/" },
          { src: "/assets/img/partners/logo_dvo.jpg", alt: "DVO", href: "https://www.dvo.be/artikel/53832-boxify-innoveert-met-flexibele-opslagdienst/" },
          { src: "/assets/img/partners/logo_flanders-today.jpg", alt: "Flander Today", href: "http://www.flanderstoday.eu/business/week-business-5-august" },
          { src: "/assets/img/partners/logo_brussel-metropole.jpg", alt: "Brussel Metropool", href: "http://onlinetouch.be/beci/2015-dot-10-brussel-metropool?html=true#/51/" },
          { src: "/assets/img/partners/logo_bruxelles-metropole.jpg", alt: "Bruxelles Metropole", href: "http://onlinetouch.be/beci/2015-dot-10-bruxelles-metropole?html=true#/51/" },
          { src: "/assets/img/partners/logo_la-capitale.jpg", alt: "La Capitale", href: "https://fr.boxify.be/files/press/LaCapitale_Aout16_2016-08-20.pdf" },
          { src: "/assets/img/partners/logo_vivacite.jpg", alt: "Vivacité", href: "https://www.youtube.com/watch?v=UpcopO6T_QY&feature=youtu.be" },
          { src: "/assets/img/partners/logo_rtl-tvi.jpg", alt: "RTL TVI", href: "http://www.rtl.be/info/video/593602.aspx" },
          { src: "/assets/img/partners/logo_bruzz.jpg", alt: "Bruzz", href: "https://www.bruzz.be/samenleving/brusselse-start-boxify-stockeert-je-overbodige-spullen-2016-08-02" },
          { src: "/assets/img/partners/logo_trends.jpg", alt: "Trends", href: "#" },
        ];
          
          const partnersCarousel = document.getElementById('carousel-partners');
          
          partners.forEach(partner => {
            const item = document.createElement('div');
            item.classList.add('item');
          
            item.innerHTML = `
              <a href="${partner.href}">
                <img src="${partner.src}" alt="${partner.alt}" />
              </a>
            `;
          
            partnersCarousel.appendChild(item);
          });
          
          $(document).ready(function() {
            $('.carousel-partners').owlCarousel({
                autoPlay: 2500,
                    items: 6,
                    itemsDesktop: [1199, 6],
                    itemsDesktopSmall: [979, 4],
                    itemsTablet: [768, 3],
                    itemsTabletSmall: [768, 2],
                    itemsMobile: [479, 2],
                    navigation: false,
                    pagination: false,
            });
          });
          





// TESTIMONIAL
$(document).ready(function() {
  function initializeOwlCarousel() {
      var isMobile = $(window).width() <= 850;

      $('.testimonies-carousel').owlCarousel({
          items: 3,
          itemsDesktop: [1199, 3],
          itemsDesktopSmall: [979, 2],
          itemsTablet: [768, 1],
          itemsMobile: [479, 1],
          navigation: !isMobile,
          navigationText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
          pagination: false,
      });
  }

  initializeOwlCarousel();

  $(window).resize(function() {
      $('.testimonies-carousel').data('owlCarousel').destroy();
      initializeOwlCarousel();
  });
});







    //FAQ
    document.querySelectorAll('.accordion-header').forEach(header => {
      header.addEventListener('click', function (e) {
        e.preventDefault();
  
        const link = this.querySelector('a');
        const icon = link.querySelector('i');
        const content = this.nextElementSibling;
        const isOpen = content.style.display === 'block';
  
        document.querySelectorAll('.accordion-content').forEach(c => c.style.display = 'none');
        document.querySelectorAll('.accordion-header').forEach(h => {
          h.classList.remove('active');
          h.querySelector('i').className = 'fa fa-plus finer-icon';
        });
  
        if (!isOpen) {
          content.style.display = 'block';
          this.classList.add('active');
          icon.className = 'fa fa-minus finer-icon';
  
          const offset = this.offsetTop;
          const windowHeight = window.innerHeight;
          const elementHeight = this.clientHeight;
          const scrollTo = offset - (windowHeight / 2) + (elementHeight / 2);
  
          window.scrollTo({
            top: scrollTo,
            behavior: 'smooth'
          });
        } else {
          content.style.display = 'none';
          this.classList.remove('active');
          icon.className = 'fa fa-plus finer-icon';
        }
      });
    });



    },
};

